import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { Box } from "@mui/material";
import "./MarkdownRenderer.css";

const MarkdownRenderer = ({ content }) => {
  return (
    <Box className="markdown-container">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          // eslint-disable-next-line jsx-a11y/heading-has-content
          h1: ({ ...props }) => <h1 className="markdown-heading1" {...props} />,
          // eslint-disable-next-line jsx-a11y/heading-has-content
          h2: ({ ...props }) => <h2 className="markdown-heading2" {...props} />,
          // eslint-disable-next-line jsx-a11y/heading-has-content
          h3: ({ ...props }) => <h3 className="markdown-heading3" {...props} />,
          // eslint-disable-next-line jsx-a11y/heading-has-content
          h4: ({ ...props }) => <h4 className="markdown-heading4" {...props} />,
          // eslint-disable-next-line jsx-a11y/heading-has-content
          h5: ({ ...props }) => <h5 className="markdown-heading5" {...props} />,
          // eslint-disable-next-line jsx-a11y/heading-has-content
          h6: ({ ...props }) => <h6 className="markdown-heading6" {...props} />,
          p: ({ ...props }) => <p className="markdown-paragraph" {...props} />,
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          a: ({ ...props }) => <a className="markdown-link" {...props} />,
          code: ({ inline, ...props }) => {
            return inline ? (
              <code className="markdown-inline-code" {...props} />
            ) : (
              <pre className="markdown-code-block">
                <code {...props} />
              </pre>
            );
          },
          ul: ({ ...props }) => <ul className="markdown-list markdown-unordered-list" {...props} />,
          ol: ({ ...props }) => <ol className="markdown-list markdown-ordered-list" {...props} />,
          li: ({ ...props }) => <li className="markdown-list-item" {...props} />,
          blockquote: ({ ...props }) => <blockquote className="markdown-blockquote" {...props} />,
          table: ({ ...props }) => <table className="markdown-table" {...props} />,
          th: ({ ...props }) => <th {...props} />,
          td: ({ ...props }) => <td {...props} />,
          br: () => <br />,
          hr: () => <hr className="markdown-hr" />,
          b: ({ ...props }) => <strong className="markdown-bold" {...props} />,
          strong: ({ ...props }) => <strong className="markdown-bold" {...props} />,
          i: ({ ...props }) => <em className="markdown-italic" {...props} />,
          em: ({ ...props }) => <em className="markdown-italic" {...props} />,
          u: ({ ...props }) => <u {...props} />,
          s: ({ ...props }) => <s className="markdown-strike" {...props} />,
          del: ({ ...props }) => <del className="markdown-strike" {...props} />,
          sup: ({ ...props }) => <sup className="markdown-sup" {...props} />,
          sub: ({ ...props }) => <sub className="markdown-sub" {...props} />,
          img: ({ ...props }) => <img className="markdown-image" {...props} alt={props.alt || ""} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  );
};

export default MarkdownRenderer;